'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RefTable = undefined;

var _xmlSharedStrings = require('./xmlSharedStrings');

let RefTable = exports.RefTable = class RefTable {
  constructor() {
    this.strings = [];
    this.known = {};
  }
  makeXsst() {
    const len = this.strings.length;
    const sst = new _xmlSharedStrings.Xsst({
      count: len,
      uniqueCount: len
    });
    for (const str of this.strings) {
      const si = new _xmlSharedStrings.Xsi({}, [new _xmlSharedStrings.Xt({}, [str])]);
      sst.children.push(si);
    }
    return sst;
  }
  addString(str) {
    if (this.known[str] === undefined) {
      const index = this.strings.length;
      this.strings.push(str);
      this.known[str] = index;
      return index;
    }
    return this.known[str];
  }
  getString(index) {
    return this.strings[index];
  }
  length() {
    return this.strings.length;
  }
};